import { useSelector } from "react-redux";

const SaleReturn = () => {
  return (
    <>
      <div className="iframe-div">
        <iframe
          title="Report Section"
          width="600"
          height="373.5"
          src="https://iipl.retool.com/embedded/public/72430673-dae2-4b1e-96ae-1d2779c821f8"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </div>
    </>
  );
};

export default SaleReturn;
